import styled from "styled-components";

import Row from "components/Form/Row";

export const Container = styled.div`
  width: 450px;
  margin-bottom: 40px;
`;

export const TitleContainer = styled(Row)`
  align-items: center;
  justify-content: space-between;
`;

export const ControlRow = styled(Row)`
  margin-bottom: 30px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const ButtonContainer = styled.div`
  display: flex;

  width: 100px;

  &:not(:last-child) {
    margin-right: 30px;
  }
`;
